export const fontDefault = "'TT Hoves', system-ui";
export const fontMonospaced = "'SFMono-Regular', Menlo, Monaco, Consolas, monospace !important";
